// extracted by mini-css-extract-plugin
export default {"holder":"partytitle_holder__C4LJp","text":"partytitle_text__SQ6D6","party-effect":"partytitle_party-effect__7Rvle"};